import { periodFormat } from 'utils/common';

export const createReqBody = (filter, customerId) => {
  return {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      role: filter.role[0] ? filter.role : '*',
      lastUpdatedAt: periodFormat(filter.lastUpdatedAt),
      score: {
        from: filter.score.from ? filter.score.from : '*',
        to: filter.score.to ? filter.score.to : '*'
      }
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
